const config = {
  title: '面试系统',
  lable_username: '账号名称',
  lable_psd: '密码',
  lable_remeb_Me: '记住我',
  forgot_psd: '忘记密码',
  login_btn: '登入',
  logSuccess: '登录系统成功！',
  logError: {
    200: '密码不正确\n或\n此账号不存在，请重新输入！',
    201: '这个账号被锁定,请与系统管理员联络',
    0: '对不起! 目前系统繁忙\n请稍后再试',
    104: '连接超时',
  },
  select_school: '请选择学校',
  school_name: '学校名称',
  next_step: '下一步',
  Traditional: '繁体中文',
  Simplified: '简体中文'
};

export default config;
